<div class="component-main-container">
  <!-- sessão header -->
  <div class="header">
    <app-page-header parentTitle="{{ 'equipments.equipments-parent-label' | translate }}"
      pageTitle="{{ 'equipments.equipments-page-label' | translate }}"></app-page-header>
  </div>

  <!-- div responsável por fazer com que a tela se comporte como uma linha -->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <!-- div responsavel por armazenas as box da página -->
      <div class="component-forms-box">
        <!-- box de tipo de registro -->
        <app-register-form></app-register-form>

        <!-- box responsável pela criação de equipamentos -->
        <div class="form-fields-box" [ngClass]="!registerEquipment ? 'closed' : ''" [formGroup]="equipmentForm">
          <h2 (click)="registerEquipmentOpen()">
            {{ "equipments.register-equipments" | translate }}
          </h2>
          <hr [ngClass]="!registerEquipment ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "equipments.form-mac-adress" | translate
                }}</mat-label>
              <input matInput formControlName="macAddress" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipments.form-serial-number" | translate }}</mat-label>
              <input matInput type="text" formControlName="serialNumber" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "equipments.form-equipment-type" | translate }}</mat-label>
              <mat-select formControlName="equipmentType" #value>
                @for (item of equipmentTypeList; track item) {
                <mat-option appearance="outline" [value]="item.id">{{
                  item.reference }} ({{ item.major }}.{{ item.minor }}.{{
                  item.revision
                  }})</mat-option>
                }
                @if (equipmentLoading) {
                <mat-option><mat-spinner [diameter]="30"></mat-spinner></mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          @if (!equipmentTypeLoading) {
          <button title="Salvar" class="btn btn-success" (click)="createEquipment()">
            {{ "equipments.button-save" | translate }}
          </button>
          }
          @if (equipmentTypeLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <div class="form-fields-box" [ngClass]="!filterEquipment ? 'closed' : ''" [formGroup]="filterForm">
          <h2 (click)="filterEquipmentOpen()">
            {{ "equipments.filter-equipments" | translate }}
          </h2>
          <hr [ngClass]="!filterEquipment ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "equipments.form-keyword" | translate }}</mat-label>
              <input matInput formControlName="search" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "equipments.form-equipment-type" | translate
                }}</mat-label>
              <mat-select formControlName="equipmentTypeId">
                @for (item of equipmentTypeList; track item) {
                <mat-option appearance="outline" [value]="item.id">{{
                  item.reference }} ({{ item.major }}.{{ item.minor }}.{{
                  item.revision
                  }})</mat-option>
                }
                @if (getEquipmentType) {
                <mat-option>
                  <mat-spinner [diameter]="30"></mat-spinner>
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          @if (!equipmentLoading) {
          <button title="{{ 'equipments.button-filter' | translate }}" class="btn btn-success"
            (click)="filterEquipments(null)">
            {{ "equipments.button-filter" | translate }}
          </button>
          }
          @if (equipmentLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (length > 0) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="this.paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="macAddress"> {{ "equipments.form-mac-adress" | translate }}
              </th>
              <th pSortableColumn="serialNumber"> {{ "equipments.form-serial-number" | translate }}
              </th>
              <th pSortableColumn="equipmentType"> {{ "equipments.form-equipment-type" | translate }}
              </th>
              <th pSortableColumn="actions"> {{ "equipments.actions-table" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.macAddress}}</td>
              <td>{{row.serialNumber}}</td>
              <td> {{ row.equipmentType.reference }} {{
                row.equipmentType.major
                }}.{{ row.equipmentType.minor }}.{{
                row.equipmentType.revision
                }}
              </td>
              <td>
                <p-button (click)="openSidebarUpdate(row)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-pen-to-square" />

                <p-button (click)="openHistoryLogsSidebar(row)" styleClass="btn-view" [rounded]="true"
                  icon="pi pi-file" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }

    @if (sideBarEdit) {
    <div class="sidebar-edit" [formGroup]="updateForm">
      <mat-icon (click)="sideBarEdit = false">clear</mat-icon>
      <h2>{{"equipments.form-edit" | translate}}</h2>
      <mat-form-field appearance="outline">
        <mat-label>{{ "equipments.form-edit-mac-adress" | translate }}</mat-label>
        <input matInput formControlName="macAddress" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ "equipments.form-edit-serial-number" | translate }}</mat-label>
        <input matInput formControlName="serialNumber" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "equipments.form-edit-equipment-type" | translate }}</mat-label>
        <mat-select formControlName="equipmentTypeId">
          @for (item of equipmentTypeList; track item) {
          <mat-option appearance="outline" [value]="item.id">
            {{ item.reference }} ({{ item.major }}.{{ item.minor }}.{{
            item.revision
            }})
          </mat-option>
          }
          @if (getEquipmentType) {
          <mat-option><mat-spinner [diameter]="30"></mat-spinner></mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (!getEquipmentType) {
      <button class="btn btn-success" (click)="updateEquipment()">
        {{ "equipments.button-edit" | translate }}
      </button>
      }
    </div>
    }
  </div>
  <ng-template #dialogTemplate let-dialogRef="dialogRef">
    <mat-dialog-content class="mat-typography">
      <div class="dialogRef" style="text-align: center;">
        @if (loadingLogs) {
        <mat-spinner [diameter]="30"></mat-spinner>
        }
        @if (loadingLogs) {
        <span style="font-size:20px; color: #2633d8"> {{'equipments.loading-logs-message' |
          translate}} </span>
        }
        @if (!loadingLogs) {
        <h1 mat-dialog-title>{{'equipments.title-installation-history-logs' | translate}} </h1>
        }
        @if (!loadingLogs) {
        <hr>
        }
        @for (item of installationLogsList; track item) {
        <div class="d-flex align-items-start flex-column text-center" style="font-size: 19px;">
          <div class="p-2">
            @if (!loadingLogs) {
            <strong> {{'equipments.start-date-time' | translate}} </strong>
            }{{item.startDatetime}}
          </div>
          <div class="p-2">
            @if (!loadingLogs) {
            <strong> {{'equipments.installation' | translate}}: </strong>
            }
            {{item.installation.reference}}
          </div>
          @if (installationLogsList.length > 1) {
          <mat-divider></mat-divider>
          }
        </div>
        }
        @if (logsNotFound) {
        <strong style="font-size:18px;"> {{'equipments.no-logs-message' | translate}} </strong>
        }
      </div>
    </mat-dialog-content>
  </ng-template>
</div>